module.exports = __webpack_public_path__ + "static/media/exclamation-icon.e31803dc.png";